import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '@/App';

/**
 * Hook for fetching team member strike data (manager/admin view)
 */
export function useTeamStrikes() {
  const [teamStrikes, setTeamStrikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeamStrikes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get('/attendance/daily/strikes');
      setTeamStrikes(response.data.team_strikes || []);
    } catch (err) {
      // Non-managers get 403, which is expected
      if (err.response?.status === 403) {
        setTeamStrikes([]);
        setError(null);
      } else {
        setError(err.response?.data?.detail || 'Failed to load team strike data');
        console.error('Team strikes fetch error:', err);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeamStrikes();
  }, [fetchTeamStrikes]);

  return { teamStrikes, loading, error, refetch: fetchTeamStrikes };
}
